export default __webpack_public_path__ + "static/qa-header-21067e6424a728a7a1190e6cf123b62b.jpg";